import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {Observable} from 'rxjs/Observable';
import {IVehicleGroupForUserListRow} from '../../../_models/vehicle';
import {VehiclesGroupsService} from '../../../_services/vehicles-groups.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {catchError, finalize} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import { PaginationParams } from '../../../_models/generic';

export class VehicleGroupDataSource implements DataSource<IVehicleGroupForUserListRow> {

    private vehiclesSubject = new BehaviorSubject<IVehicleGroupForUserListRow[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    public paginatorTotalCount: number;

    constructor(private vehiclegroupService: VehiclesGroupsService) {

    }

    loadAdminVehicles(params: PaginationParams) {
        this.loadingSubject.next(true);

        this.vehiclegroupService.getVehiclesGroupsForUserList(params).pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe(vehicles => {
                console.log('find vehicles service  in Datasource: ', vehicles);
                this.paginatorTotalCount = vehicles['count'];
                this.vehiclesSubject.next(vehicles['results']);
            });

    }

    connect(collectionViewer: CollectionViewer): Observable<IVehicleGroupForUserListRow[]> {
        console.log("Connecting Vehicles Admin data source");
        return this.vehiclesSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.vehiclesSubject.complete();
        this.loadingSubject.complete();
    }

}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-vehicle-group/vehicle-groups.datasource.ts